import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const SchedulePage = () => <Guide content={guides.schedule} />
